/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Hero_TabInputs */

const vi_shop_home_hero_tab = /** @type {(inputs: Shop_Home_Hero_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên tab`)
};

/**

* @param {Shop_Home_Hero_TabInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_hero_tab = /** @type {((inputs?: Shop_Home_Hero_TabInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Hero_TabInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_hero_tab(inputs)
});